import React, {useMemo} from "react";
import {TextField} from "@mui/material";
import {SelectField} from "@atttomyx/react-components";
import {NodeField} from "../fields";
import {arrays, forms, objects} from "@atttomyx/shared-utils";
import {NODE_ANONYMOUS} from "../../constants";
import "./offeringFilters.css";

const OfferingFilters = (props) => {
    const { formProps, data, onChange : onSync } = props;
    const { unique, nodes } = formProps;

    const withAnonymous = useMemo(() => {
        const array = arrays.addAll([], nodes);

        arrays.prependTo(array, NODE_ANONYMOUS);

        return array;
    }, [nodes]);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="offering-filters">
        <div className="cards">
            <div className="card">
                <div className="field">
                    <NodeField
                        nodes={withAnonymous}
                        value={data.nodeId}
                        onChange={(nodeId) => onChange("nodeId", nodeId)}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Category"
                        value={forms.sanitizeValue(data.category)}
                        onChange={(value) => onChange("category", value)}
                        options={unique.categories}
                    />
                </div>
                <div className="field">
                    <SelectField
                        label="Type"
                        value={forms.sanitizeValue(data.type)}
                        onChange={(value) => onChange("type", value)}
                        options={unique.types}
                    />
                </div>
            </div>
            <div className="card">
                <div className="field">
                    <TextField
                        label="More than or equal to"
                        type="number"
                        value={forms.sanitizeValue(data.minimum)}
                        onChange={(event) => onChange("minimum", event.target.value)}
                        inputProps={{
                            min: 0,
                        }}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Less than or equal to"
                        type="number"
                        value={forms.sanitizeValue(data.maximum)}
                        onChange={(event) => onChange("maximum", event.target.value)}
                        inputProps={{
                            min: 0,
                        }}
                    />
                </div>
            </div>
            <div className="card">
                <div className="field">
                    <TextField
                        label="After (inclusive)"
                        type="date"
                        value={forms.sanitizeValue(data.after)}
                        onChange={(event) => onChange("after", event.target.value)}
                    />
                </div>
                <div className="field">
                    <TextField
                        label="Before (inclusive)"
                        type="date"
                        value={forms.sanitizeValue(data.before)}
                        onChange={(event) => onChange("before", event.target.value)}
                    />
                </div>
            </div>
        </div>
    </div>
}

export default OfferingFilters;
